var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["modal fade", { show: _vm.showModal, "d-block": _vm.showModal }],
      attrs: { tabindex: "-1", id: this.id || "none" },
      on: {
        hidden: function ($event) {
          return _vm.$emit("update:open", false)
        },
      },
    },
    [_vm._t("body")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }